<div class="modal-form container">
    <h2 mat-dialog-title class="jumbotron-heading">Company Disclaimers</h2>

    <mat-dialog-content class="mat-typography">
        <lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>

        <div class="edit">

            <!--Copyright-->
            <div>
                <div><b>Copyright</b></div>
                <div class="disclaimerDescription">The default HomeDashboard footer will include the year and copyright, as well as your company name and license number. This has been pre-populated with fields we have for your company.</div>
                <lgv-company-copyright [companyInfo]="companyInfoParam"></lgv-company-copyright>
            </div>

            <!--Footer Links-->
            <div>
                <div class="Vert-15"></div>
                <div><b>Footer Links</b></div>
                <div class="disclaimerDescription">The default footer will include the your company name, address, and any contact information or social media you include. The footer links you add will show up in your footer and link to your company’s website, including, but not limited to Privacy Policy, Terms of Use, Disclosures.</div>


                <div [formGroup]="disclaimerFG" class="form showUnTouchedInvalidFields">
                    <div formArrayName="disclaimerArray">

                        <div *ngIf="disclaimerArray && disclaimerArray?.controls?.length == 0">
                            There are currently no disclaimers.  Click the "Add Disclaimer" below to get started.
                        </div>
                        <div class="Vert-10"></div>

                        <ng-container *ngFor="let slForm of disclaimerArray.controls; let i = index">

                            <ng-container *ngIf="lgvConstants.isLinkFooterDisclaimer(slForm?.value)">
                                <div [formGroup]="slForm" class="row">

                                    <div class="col-12">
                                        <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label>Link URL</mat-label>
                                            <input type="text" matInput formControlName="value">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-8">
                                        <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label>Link Text</mat-label>
                                            <input type="text" matInput formControlName="title">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-3">
                                        <mat-form-field appearance="outline" floatLabel="always">
                                            <mat-label>Display Order</mat-label>
                                            <input type="number" matInput formControlName="displayOrder">
                                        </mat-form-field>
                                    </div>
                                    <div class="col-1 trashCanAdjustment">
                                        <a class="buttonIcon grayIcon" (click)="removeDisclaimer(i)"><fa-icon icon="trash"></fa-icon></a>
                                    </div>

                                    <div class="d-lg-none col-12 Vert-25"></div>
                                </div>
                            </ng-container>

                        </ng-container>

                        <div class="row">
                            <div class="col-12">
                                <a style="cursor:pointer;" (click)="onAddFooterLink()"><fa-icon icon="plus"></fa-icon> Add Link</a>
                                <div class="Vert-25"></div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>



            <!--Email Disclaimers-->
            <div>
                <div class="Vert-15"></div>
                <div><b>Email Disclaimers</b></div>
                <div class="disclaimerDescription">Enter the text that you want to include at the bottom of your branded emails to your clients. If you have multiple text fields, drag and drop the text fields to show in the order you want.</div>


                <div [formGroup]="disclaimerFG" class="form showUnTouchedInvalidFields">
                    <div formArrayName="disclaimerArray">

                        <div *ngIf="disclaimerArray && disclaimerArray?.controls?.length == 0">
                            There are currently no disclaimers.  Click the "Add Disclaimer" below to get started.
                        </div>
                        <div class="Vert-10"></div>

                        <div cdkDropList
                             [cdkDropListData]="disclaimerArray.controls"
                             class="drag-n-drop-list"
                             (cdkDropListDropped)="onDrop($event, DisclosureType.Text)">

                            <div *ngFor="let slForm of disclaimerArray.controls; let i = index" cdkDrag>

                                <div class="drag-n-drop-custom-placeholder" *cdkDragPlaceholder></div>

                                <ng-container *ngIf="lgvConstants.isTextEmailDisclaimer(slForm?.value)">
                                    <div [formGroup]="slForm" class="row">

                                        <div class="col-10">
                                            <mat-form-field appearance="outline" floatLabel="always">
                                                <mat-label>Email Disclaimer</mat-label>
                                                <textarea matInput formControlName="value" rows="5"></textarea>
                                            </mat-form-field>
                                        </div>
                                        <div class="col-2 trashCanAdjustment">
                                            <a class="buttonIcon grayIcon" (click)="removeDisclaimer(i)"><fa-icon icon="trash"></fa-icon></a>
                                        </div>

                                        <div class="d-lg-none col-12 Vert-25"></div>

                                        <!--<hr class="separator" />-->
                                    </div>
                                </ng-container>

                            </div>


                        </div>


                        <div class="row">
                            <div class="col-12">
                                <a (click)="onAddEmailDisclaimer()" style="cursor:pointer;" ><fa-icon icon="plus"></fa-icon> Add Email Disclaimer</a>
                                <div class="Vert-25"></div>
                            </div>
                        </div>

                    </div>

                </div>
            </div>



            <div class="Vert-10"></div>

            <div class="row">
                <div class="col-12" align="end">

                    <button mat-button class="btn btn-primary float-end" (click)="onSubmit()"
                            [disabled]="(isLoading$ | async) || !disclaimerFG.valid">
                        Submit
                    </button>

                    <button mat-stroked-button (click)="onCancel()" class="btn btn-secondary float-end"
                            style="margin-right:10px;">
                        Cancel
                    </button>
                </div>
            </div>
            <div class="Vert-15"></div>

        </div>


    </mat-dialog-content>

</div>
